<style type="text/css">
.v-sidebar-menu .vsm-title {
    font-size: 15px;
    color: #000000;
}
.v-sidebar-menu .vsm-arrow {
    width: 30px;
    font-size: 23px;
    text-align: center;
    font-style: normal;
    font-weight: 1000;
    position: absolute;
    right: 10px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    -webkit-transition: 0.3s -webkit-transform;
    transition: 0.3s -webkit-transform;
    transition: 0.3s transform;
    transition: 0.3s transform, 0.3s -webkit-transform;
}
.vsm-link.active{
  font-weight: 600 !important;
  background: #c1d0da!important;
}
.v-sidebar-menu .vsm-item.first-item>.vsm-link>.vsm-icon {
    height: 30px;
    line-height: 30px;
    width: 30px;
    text-align: center;
    border-radius: 3px;
}
  .v-sidebar-menu{
    top: 55px !important;
    width: 270px!important;
    position: fixed !important;
    padding-bottom: 0px !important;
    max-height: 91.5vh !important;
    z-index: 0 !important;
  }
  .v-sidebar-menu  .vsm-item .vsm-link.active i {
      width: 25px;
      color: #fff;
      background-color: #f68607;
      text-align: center;
      border-radius: 3px;
      font-size: 12px;
  }
  .v-sidebar-menu.white-theme .collapse-btn{
    display: none !important;
  }
  .v-sidebar-menu .vsm-item {
    border-bottom: 1px dotted #b6b7b8;
  }
  .v-sidebar-menu .vsm-arrow:after{font-family: FontAwesome!important;}
  .v-sidebar-menu .collapse-btn:after {
  content: "\f07e";
  font-family: FontAwesome !important;

  }
  .v-sidebar-menu .vsm-link {
    position: relative;
    display: block;
    font-size: 16px;
    font-weight: 400;
    padding: 9px;
    line-height: 30px;
    text-decoration: none;
    z-index: 20;
    -webkit-transition: 0.3s all;
    transition: 0.3s all;
}
  .v-sidebar-menu .collapse-btn:after {
    content: '\f07e' !important;
    font: normal normal normal 15px/1 FontAwesome !important;
    color: #424242 !important;
    right: 50% !important;
    top: 7% !important;
    height: 34px !important;
    padding: 15px 0px 0px 8px !important;
    position: absolute !important;
    pointer-events: none !important;
  }
  .v-sidebar-menu .vsm-dropdown>.vsm-list {
    padding:0px !important;
    padding-left: 5px !important;
  }
  .v-sidebar-menu.vsm-collapsed{
    display: none !important;
  }
  .v-sidebar-menu .vsm-title{
    font-size: 15px;
  }
.sidebar-fixed .main, .sidebar-fixed .app-footer{
  margin-left:270px;
}

.v-sidebar-menu.white-theme.vsm-default .vsm-item.first-item.open-item>.vsm-link>.vsm-title {
    color: #fff;
}
.v-sidebar-menu .vsm-arrow.open-arrow {
    -webkit-transform: translateY(-50%) rotate(90deg);
    transform: translateY(-50%) rotate(90deg);
    color: #000;
}
.vue-treeselect__option--disabled .vue-treeselect__label-container .vue-treeselect__label {
  color: rgba(0,0,0,.25) !important;
}
</style>

<template>
  <sidebar-menu :menu="permissions" theme = "white-theme" :showOneChild = "true"></sidebar-menu>
</template>

<script>
  import CryptoJS from 'crypto-js';
  import { SidebarMenu } from 'vue-sidebar-menu'
  export default {
    name: 'sidebar',
    components: {
    SidebarMenu,
    },
    data () {
      return {

        permissions: [],
        navItem: [],

    }
  },
    mounted(){
		var permissionEncrypt = window.localStorage.getItem('cargoAutoaccesspermissiondata')
		var bytes  = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);

		this.navItem=JSON.parse(plaintext);
    let preJson = this.navItem;
    let finalJson = [];
        if (preJson.length > 0) {
            preJson.forEach(function(entry) {
                var innerArr = [];
                if (entry.children.length > 0) {
                    entry.children.forEach(function(inner) {
                    let temparr = [];
                    if(inner.children.length > 0){
                    inner.children.forEach(function(el) {
                      if(el.ismenu){
                        temparr.push({
                            "title": el.name,
                            "icon": el.icons,
                            "href": el.url
                        });
                        }
                      });
                      }
                      if(inner.ismenu && inner.children.length > 0){
                    innerArr.push({
                        "title": inner.name,
                        "icon": inner.icons,
                        "child": temparr
                    });
                  }else{
                        innerArr.push({
                        "title": inner.name,
                        "icon": inner.icons,
                        "href": inner.url,
                    });
                  }
                    });

                    if(entry.ismenu){
                      finalJson.push({
                          "title": entry.name,
                          "icon": entry.icons,
                          "child": innerArr
                      });
                    }
                } else {
                    if(entry.ismenu){
                      finalJson.push({
                          "title": entry.name,
                          "icon": entry.icons,
                          "href": entry.url
                      });
                    }
                }
            })
        }
        this.permissions = finalJson;
    },
    methods: {
      handleClick (e) {
        e.preventDefault();
        e.target.parentElement.classList.toggle('open');
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Sidebar.vue?380cb878